import React from 'react';
import '../../styles/AuthForm.css';
import '../../styles/embla.css';
import Typography from '../../components/Typography';
// import image1 from '../../images/auth1.png';
// import image2 from '../../images/auth2.png';
// import image3 from '../../images/auth3.png';
import line71 from '../../images/Line 71.png';
import EmblaCarousel from './EmblaCarousel';
const OPTIONS = { loop: true }
const SLIDE_COUNT = 4
const SLIDES = Array.from(Array(SLIDE_COUNT).keys())
const RightComponent = () => {

    return (
        <div className="bg-[#DF0F11] right-side min-h-screen overflow-hidden">
            <div className="absolute z-0">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="822.84"
                    height="945"
                    viewBox="0 0 822.84 945"
                    fill="none"
                >
                    <path
                        d="M644.275 321.048L469.457 268.619C612.209 158.385 759.497 45.8941 902.313 -64.2738C800.131 41.5803 694.988 152.014 592.869 257.868C593.121 258.797 593.436 259.726 593.688 260.589C656.622 280.631 719.494 300.674 783.184 320.916C820.29 255.08 857.207 189.643 894.06 124.14C930.914 58.5701 967.893 -6.93338 1004.62 -72.6359C1022.89 -105.288 1041.73 -138.737 1060.44 -172.252C1079.21 -205.7 1097.92 -239.215 1116 -272C962.853 -161.633 807.879 -50.0714 652.969 61.4902C497.995 172.985 343.084 284.547 189.874 394.98C343.651 439.844 500.956 485.238 656.56 530.633C600.807 590.761 544.046 651.552 487.348 712.211C430.651 772.87 374.079 833.396 318.83 892.992C336.217 868.172 357.007 837.776 374.394 812.955C392.096 787.669 409.798 762.384 427.501 737.098C445.014 712.078 462.716 687.124 479.978 661.905C497.113 636.952 514.563 610.471 531.006 584.92C443.25 691.704 354.424 799.549 265.471 907.46C176.582 1015.31 87.6925 1123.22 0 1230C360.345 974.158 725.353 715.994 1087.34 459.024C1089.04 457.829 1090.74 456.635 1092.44 455.374L644.338 320.982H644.212L644.275 321.048Z"
                        fill="#E22729"
                    />
                </svg>
            </div>
            <Typography
                text={'TOP INVESTMENTS RIGHT NOW'}
                size={'48px'}
                lineheight={'48px'}
                family={'Supply'}
                transform={'uppercase'}
                color={'#FFF'}
                className="text-center relative z-10 mx-auto lg:px-32 pt-36"
            />

            {/* Carousel Container */}
            <div className="relative z-10 mt-14 overflow-hidden">
                <EmblaCarousel slides={SLIDES} options={OPTIONS} />
            </div>

            <div className="relative flex flex-col justify-center max-w-[294px] left-1/2 transform -translate-x-1/2 text-center mt-6">
                <Typography
                    text={'VENTURE INCUBATOR'}
                    color={'#FFF'}
                    size={'24px'}
                    family={'Supply'}
                    lineheight={'normal'}
                    transform={'uppercase'}
                    weight={500}
                />
                <img src={line71} alt="line71" className="mt-5" />
                <div className="mt-4 flex justify-between">
                    <Typography text={'120 days'} color={'#FFF'} weight={500} size={'16px'} lineheight={'32px'} />
                    <Typography text={'10%ROI'} color={'#FFF'} weight={500} size={'16px'} lineheight={'32px'} />
                </div>
                <div className="mt-6 flex justify-center items-center bg-white" style={{ borderRadius: '2px 10px', height: '49px' }}>
                    <button>
                        <Typography text={'INVEST NOW'} size={'16px'} family={'Supply'} weight={400} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RightComponent;